<app-header-inner></app-header-inner>
<!-- Subheader Start -->
<div  class="subheader dark-overlay dark-overlay-2" 
style="padding: 126px 0 2px;min-height: 211px !important;background-image: url('https://s3.eu-central-1.amazonaws.com/heek-media/images/industries/food/food-burger/cover-2.jpg')">
    <div class="container">
      <div class="subheader-inner">
        <h1>{{res_name}}</h1>
        
      </div>

    </div>
  </div>
  <!-- Subheader End -->

  <!-- Menu Categories Start -->
   <!-- You can now use your library component in app.component.html -->
  
  <div class="ct-menu-categories menu-filter" style="    padding-top: 0px;padding-bottom: 0px;">
    <div class="container" style="max-width: 97%;">
		<div class="col-lg-12">
		<div  *ngIf="menuSpin" class="category-box-icon d-flex">
			<i class="fas fa-spinner spinner"></i>
		</div>
		</div>
		<div id="thumbnail-slider" style="height: auto;">
                <div class="inner">
                    <ul >
					<li *ngFor="let menu of menuResult;let indexof=index">
							<a  *ngIf='menu.id==="deal"' (click)="getMenu(0, 'no')"  class="ct-menu-category-item "  >
								
								<div class="menu-category-desc pt-4 pb-4 " >
									<h6 id="menu_{{menu.id}}" class="p-2 menu-class menu-default-border ml-4" 
									
									>{{menu.name}}</h6>
								</div>
							</a>
							<a  *ngIf='menu.id!="deal"' (click)="getSubmenu(menu.id)"  class="ct-menu-category-item "  >
							
							<div class="menu-category-desc pt-4 pb-4 " >
								<h6 id="menu_{{menu.id}}" class="p-2 menu-class menu-default-border ml-4" 
								
								>{{menu.name}}</h6>
							</div>
							</a>
						</li> 
						
					</ul>
                </div>
            </div>
			
	
     <!--  <div class="menu-category-slider" style="display:none">
		   
			
			<ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig" (init)="slickInit($event)"
			(breakpoint)="breakpoint($event)" (afterChange)="afterChange($event)" (beforeChange)="beforeChange($event)">
			<div ngxSlickItem *ngFor="let menu of menuResult;let indexof=index" class="slide">
				
				<a  *ngIf='menu.id==="deal"' (click)="getMenu(0)"  class="ct-menu-category-item "  >
				
				<div class="menu-category-desc pt-4 pb-4 " >
					<h6 id="menu_{{menu.id}}" class="p-2 menu-class menu-default-border ml-4" 
					
					>{{menu.name}}</h6>
				</div>
				</a>
				
				<a  *ngIf='menu.id!="deal"' (click)="getSubmenu(menu.id)"  class="ct-menu-category-item "  >
				
				<div class="menu-category-desc pt-4 pb-4 " >
					<h6 id="menu_{{menu.id}}" class="p-2 menu-class menu-default-border ml-4" 
					
					>{{menu.name}}</h6>
				</div>
				</a>
				
			</div>
		  </ngx-slick-carousel>
	  </div> -->
    </div>
  </div>
  <!-- Menu Categories End -->

  <!-- Menu Wrapper Start -->
  <div class="section section-padding">
    <div class="container">

      <div class="row" style="height: auto;">
		<div class="col-lg-12" *ngIf="isMenuFound==='0'">
			<p style="text-align:center;font-size:30px;font-weight:1000">No menu available</p>
		</div>
		<div class="col-lg-12">
			<div  *ngIf="submenuSpin" class="category-box-icon d-flex">
				<i class="fas fa-spinner spinner"></i>
			</div>
		</div>
        <!-- Product Start -->
        <div class="col-lg-4 col-md-6 pizzas" *ngFor="let subMenu of subMenuList; let index = index">
          <div class="product" >
            <a class="product-thumb" style="height:200px" id=""> 
			<img *ngIf="subMenu.dealData" [src]="BASEURL_DEAL_IMGS+subMenu.image"
			(error)="updateUrl(subMenu.id)"
			id="submenu_image_{{subMenu.id}}" style="height:200px">
			
			<img *ngIf="!subMenu.dealData" [src]="BASEURL_SUBMENU_IMGS+subMenu.image" (error)="updateUrl(subMenu.id)"
			id="submenu_image_{{subMenu.id}}" style="height:200px">

			</a>
            <div class="product-body">
              <div class="product-desc">
                <h4> <a style="color:black">{{subMenu.name}}</a> </h4>
                <p>{{subMenu.desc}}</p>
                <span *ngIf="subMenu.is_size_applicable==='0'" >
				<p class="product-price" *ngIf="subMenu.price!=''; else elseBlock" >${{subMenu.price | number : '1.2-2' }}</p>
			    <ng-template #elseBlock>  
					<p class="product-price">$0.00</p>
				</ng-template> 
				
				</span>
				
				<span *ngIf="subMenu.is_size_applicable==='1'" >
				<p class="product-price" *ngIf="subMenu.menu_size_first_price!=''; else elseBlock" >${{subMenu.menu_size_first_price | number : '1.2-2' }}</p>
			    <ng-template #elseBlock>  
					<p class="product-price">$0.00</p>
				</ng-template> 
				</span>
				<a (click)="getModifers(subMenu)" *ngIf="subMenu.disable==='0'" style="margin-left: 10px;" class="btn-custom secondary btn-sm shadow-none" data-toggle="modal" data-target="#customizeModal"> Order <i class="fas fa-shopping-cart"></i> </a>
				<button  *ngIf="subMenu.disable==='1'" style="margin-left: 10px;" class=" disabled-btn btn-sm shadow-none" disabled> Order <i class="fas fa-shopping-cart"></i> </button>
              </div>
            
            </div>
          </div>
        </div>
        <!-- Product End -->



      </div>

    </div>
  </div>
  <!-- Menu Wrapper End -->
  
<app-footer></app-footer>
